import React from 'react';

const SPEAKER_STYLES = [
  'bg-sky-600/15 border-sky-500/30 text-sky-300',
  'bg-emerald-600/15 border-emerald-500/30 text-emerald-300',
  'bg-amber-600/15 border-amber-500/30 text-amber-300',
  'bg-fuchsia-600/15 border-fuchsia-500/30 text-fuchsia-300',
  'bg-rose-600/15 border-rose-500/30 text-rose-300',
  'bg-indigo-600/15 border-indigo-500/30 text-indigo-300',
];

function pickStyleIndex(label) {
  const m = String(label || '').match(/SPEAKER\s+(\d+)/i);
  if (m) return Number(m[1]) % SPEAKER_STYLES.length;
  let h = 0;
  for (let i = 0; i < String(label).length; i++) {
    h = (h * 31 + String(label).charCodeAt(i)) >>> 0;
  }
  return h % SPEAKER_STYLES.length;
}

function SpeakerBadge({ label }) {
  const idx = pickStyleIndex(label);
  const cls = SPEAKER_STYLES[idx];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}

export default function Transcript({ text, segments = [] }) {
  const parts = Array.isArray(segments) && segments.length
    ? segments.map(s => ({ speaker: s.speaker, text: s.text, start: s.start }))
    : (() => {
      if (!text) return [];
      const chunks = text.split(/(?=SPEAKER \d)/).filter(Boolean);
      return chunks.map(seg => {
        const m = seg.match(/SPEAKER (\d+)(.*?)(?=(SPEAKER \d|$))/s);
        return m ? { speaker: `SPEAKER ${m[1]}`, text: (m[2] || '').trim(), start: null } : null;
      }).filter(Boolean);
    })();

  const seek = (t) => {
    if (typeof t !== 'number') return;
    window.dispatchEvent(new CustomEvent('seek-audio', { detail: { time: t } }));
  };

  return (
    <div className="w-full">
      {parts.map((s, i) => (
        <div
          key={i}
          className={`mb-2 p-3 rounded-md ${i % 2 === 0 ? 'bg-[#0e1320]/60' : 'bg-[#0e1320]/30'} border border-[#1f2638]`}
          onClick={() => (s.start != null ? seek(s.start) : null)}
          style={{ cursor: s.start != null ? 'pointer' : 'default' }}
          title={s.start != null ? `Скок до ${s.start.toFixed(2)}s` : undefined}
        >
          <div className="mb-1 flex items-center justify-between">
            <div className="text-sm font-semibold text-slate-200">
              <SpeakerBadge label={s.speaker} />
            </div>
            {s.start != null && (
              <span className="text-[11px] text-slate-500 tabular-nums">{s.start.toFixed(2)}s</span>
            )}
          </div>
          <div className="text-[15px] leading-relaxed text-slate-200 whitespace-pre-wrap">{s.text}</div>
        </div>
      ))}
    </div>
  );
}
